<section class="hero-section animated fadeIn">
  <div id="hero_sec"></div>
  <div class="breadcrumb-list">
    <app-breadcrumb-list
      [partsOfUrl]="partsOfUrl"
      [transparent]="true"
      [standard_max_width]="true"
    >
    </app-breadcrumb-list>
  </div>

  <div class="wrapper">
    <div class="header_container">
      <div class="hero-section-text">
        <div [ngClass]="{ isLoading: dataIsLoading }">
          <h1>{{ title }}</h1>
        </div>
        @if (entityData[0]) {
          <div class="button_box">
            <a [href]="generateUrl(entityData[0])">
              <app-generic-button-with-arrow
                [label]="entityData[0].title || entityData[0]?.tT"
              >
              </app-generic-button-with-arrow>
            </a>
          </div>
        }
      </div>
    </div>
    <div class="img_container">
      <div class="img_wrap">
        @if (headerImg) {
          <div
            class="img_div"
            [ngStyle]="{
              backgroundImage: 'url(' + headerImg + ')'
            }"
          ></div>
        }
      </div>
    </div>
  </div>
</section>
